import styled from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 50px;
    margin-bottom: 100px;
    padding: 0 10%;

    @media (max-width: 1300px) {
        padding: 0 5%;
    }
`;

export const StyledTitle = styled.h2`
    font-size: 40px;
    color: white;

    @media (max-width: 650px) {
        font-size: 24px;
    }  
`;

export const StyledProfileBanner = styled.div`
    border-radius: 24px;
    overflow: hidden;
    border: 1px solid #FFF;
    padding-bottom: 30px;
`

export const StyledProfileInfo = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 20px;
`

export const StyledProfileInfoTop = styled.div`
    display: flex;
    flex-direction: column;
    padding-left: 180px;
    position: relative;

    @media (max-width: 700px) {
        padding-left: 0;
    }
`

export const StyledProfileInfoBottom = styled.div`
    display: flex;
    flex-direction: row;
    gap: 2rem;
    margin-top: 20px;
    flex-wrap: wrap;

    @media (max-width: 1100px) {
        gap: 1rem;
    }
`

export const StyledProfileImage = styled.img`
    border: 1px solid #000;
    border-radius: 100%;
    width: 150px;
    height: 150px;
    position: absolute;
    top: -75px;
    left: 0;
    object-fit: cover;

    @media (max-width: 700px) {
        top: -180px;
        left: 50%;
        transform: translate(-50%, 0);
    }
`

export const StyledProfileName = styled.h2`
    font-size: 24px;
    color: white;
    margin: 0;
    margin-right: 40px;
`

export const StyledProfilePeriod = styled.h5`
    font-size: 12px;
    color: white;
    margin: 0;
    opacity: 0.5;
`

export const StyledAddressTitle = styled.h4`
    font-size: 14px;
    color: white;
    margin: 0;
    margin-right: 5px;
`

export const StyledProfileEditTitle = styled.h5`
    font-size: 12px;
    color: white;
    margin: 0;
    opacity: 0.5;
    margin-bottom: 15px;
`

export const StyledProfileAvatarTitle = styled.h5`
    font-size: 12px;
    color: white;
    margin: 0;
    opacity: 0.5;
    margin-top: 25px;
    margin-bottom: 15px;
`